import { render, staticRenderFns } from "./BulkActionModal.vue?vue&type=template&id=830523b2&scoped=true&"
import script from "./BulkActionModal.vue?vue&type=script&lang=js&"
export * from "./BulkActionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830523b2",
  null
  
)

export default component.exports